import React from 'react';

export default props => (
    <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
        <g fill={props.color}>
            <path d="M14.6,14.4l1.4-1.4c-1.1-.3-2.3-.5-3.5-.5h0C5.6,12.5,0,18.1,0,25h25c0-3.3-1.2-6.2-3.3-8.5l-1.2,1.2c1.4,1.5,2.3,3.4,2.7,5.5H1.8c.8-5.2,5.3-9.1,10.7-9.1,0,0,1.3,0,2.1.3Z"/>
            <path d="M23.9,12c.3-.3.3-.6,0-.9l-1.5-1.5c-.3-.3-.6-.3-.9,0l-1.2,1.2,2.3,2.3,1.2-1.2ZM22.3,14l-2.6-2.6-7.1,7.1v2.6h2.6l7.1-7.1Z"/>
            <path d="M12.5,1.7c2.5,0,4.6,2.1,4.6,4.6s-2.1,4.6-4.6,4.6-4.6-2.1-4.6-4.6S10,1.7,12.5,1.7M12.5,0c-3.5,0-6.3,2.8-6.3,6.3s2.8,6.3,6.3,6.3,6.3-2.8,6.3-6.3S16,0,12.5,0h0Z"/>
        </g>
    </svg>
  );
  
